import { render, staticRenderFns } from "./BlocoCategoriaMonitoramentoSocioambiental.vue?vue&type=template&id=c19b1af0&scoped=true&lang=pug"
import script from "./BlocoCategoriaMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoCategoriaMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoCategoriaMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=c19b1af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19b1af0",
  null
  
)

export default component.exports